import './styles/style.scss';
import * as React from 'react';
import { render } from 'react-dom';
import { App } from './components/App';

render(React.createElement(App), document.getElementById("root"));
